import { ConsentAlertsPage } from './consent-alerts/consent-alerts';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Dashboard } from './dashboard/dashboard';
import { Doctor } from './doctor/doctor';
import { Products } from './products/products';
import { RescueOrders } from './rescue-orders/rescue-orders';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTableModule } from '@angular/material/table';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogModule,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { LoginPage } from './auth/login/login.page';
import { RecoveryAccessPage } from './auth/recovery-access/recovery-access.page';
import { SignUpPage } from './auth/sign-up/sign-up.page';
import { ProductEdit } from './products/product-edit/product-edit';
import { EditDoctor } from './doctor/edit-doctor/edit-doctor';
import { EditRescue } from './rescue-orders/edit-rescue/edit-rescue';
import { ProductRegister } from './products/product-register/product-register';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgOtpInputModule } from 'ng-otp-input';
import { NgxEditorComponent, NgxEditorMenuComponent } from 'ngx-editor';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core'; // Necessário para trabalhar com datas nativas
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TextFieldModule } from '@angular/cdk/text-field';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { SearchableSelect } from '../components/searchable-select/searchable-select';
import { ImportPreview } from './rescue-orders/import-preview/import-preview';
import { CommunicationsHistory } from './communications-history/communications-history';
import { Dispatches } from './dispatches/dispatches';
import { TemplatePicker } from './dispatches/template-picker/template-picker';

@NgModule({
  declarations: [
    ConsentAlertsPage,
    Dashboard,
    Doctor,
    Products,
    RescueOrders,
    LoginPage,
    RecoveryAccessPage,
    SignUpPage,
    ProductEdit,
    EditDoctor,
    EditRescue,
    ProductRegister,
    SearchableSelect,
    ImportPreview,
    CommunicationsHistory,
    Dispatches,
    TemplatePicker,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    MatTableModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatDialogModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatPaginatorModule,
    MatCheckboxModule,
    NgOtpInputModule,
    NgxEditorComponent,
    NgxEditorMenuComponent,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTooltipModule,
    TextFieldModule,
    MatChipsModule,
    MatExpansionModule,
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }],
})
export class PagesModule {}
